import log from 'salvo-lite/log'
import Slick from 'vue-slick'
import Vue from 'vue'
import Helpers from '../helpers/Helpers'

class RecentlyViewed {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._newProduct = null
        this._recentlyViewed = JSON.parse(sessionStorage.getItem('recently-viewed'))
        this._settings = JSON.parse(elem.parentNode.querySelector('[data-settings]').innerHTML)
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        if (document.querySelector('[data-recently-viewed-product')) {
            this._newProduct = JSON.parse(document.querySelector('[data-recently-viewed-product').innerHTML)
        }
        let products = []
        if (this._recentlyViewed) {
            if (this._newProduct) {
                products = this._recentlyViewed.filter(product => !(product.handle === this._newProduct.handle)).reverse()
            } else {
                products = this._recentlyViewed.reverse()
            }
        }
        if (this._newProduct) {
            this._addProduct()
        }
        const el = this._elem
        const settings = this._settings
        const vue = new Vue({
            el: el,
            data: {
                products: products,
                settings: settings
            },
            computed: {

            },
            components: {
                'slick': Slick
            },
            mounted () {
                if (this.products.length > 0) {
                    this.$el.classList.remove('visually-hidden')
                    this._alignArrows()
                }
            },
            filters: {
                money (n) {
                    return Helpers.formatMoney(n)
                },
                img_url (imageSrc, dimensions) {
                    return Helpers.getSizedImageUrl(imageSrc, dimensions)
                }
            },
            methods: {
                _alignArrows: function () {
                    const width = document.querySelector('.recently-viewed__products').offsetWidth
                    let top = 0
                    if (window.innerWidth < 481) {
                        top = (width - 20) / 2
                    } else if (window.innerWidth < 769) {
                        top = ((width - 40) / 2) / 2
                    } else {
                        top = ((width - 60) / 3) / 2
                    }
                    const arrows = this.$el.querySelectorAll('.slider-arrow')
                    arrows.forEach(arrow => {
                        arrow.style.top = top + 'px'
                    })
                }
            }
        })

        window.vueJob = vue
    }
    _addProduct () {
        let add = true
        let newArray = this._recentlyViewed ? this._recentlyViewed : []
        newArray.forEach(item => {
            if (item.handle === this._newProduct.handle) {
                add = false
            }
        })
        if (add) {
            newArray.push(this._newProduct)
        }
        if (newArray.length > 12) {
            let reverse = newArray.reverse()
            const itemToRemove = reverse.pop()
            newArray = reverse.filter(product => !(product.handle === itemToRemove.handle)).reverse()
        }
        sessionStorage.setItem('recently-viewed', JSON.stringify(newArray))
    }
}

export default RecentlyViewed



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RecentlyViewed.js